<template>
  <div class="h-full p-sm">
    <ArendeManagement
      v-if="arbetsgivareStore.arbetsgivare.foretag"
      :organisationsnummer="
        arbetsgivareStore.arbetsgivare.foretag.organisationsnummer
      "
    />
  </div>
</template>

<script setup lang="ts">
import { useArbetsgivareStore } from "./store";
import ArendeManagement from "./arende-management/ArendeManagement.vue";

const arbetsgivareStore = useArbetsgivareStore();
</script>
